import type {
  WidgetButtonThemeEnum,
  WidgetContactFormModeEnum,
  WidgetIconTypeEnum,
  WidgetPlacementEnum,
  WidgetPreviewModeEnum,
} from '@shared/api';
import type { ContactFormFieldType } from './types';

export const FONT_FAMILIES = ['Inter Tight', 'Inter', 'Roboto', 'Raleway', 'Nunito Sans'] as const;

export const BUTTON_THEMES: WidgetButtonThemeEnum[] = ['light', 'dark', 'custom'];
export const BUTTON_THEME_COLORS = {
  light: {
    background: '#FFFFFF',
    text: '#02071D',
  },
  dark: {
    background: '#02071D',
    text: '#FFFFFF',
  },
} as const;
export const ICON_TYPES: WidgetIconTypeEnum[] = ['default', 'custom'];
export const PREVIEW_MODES: WidgetPreviewModeEnum[] = ['dynamic', 'static'];
export const CONTACT_FORM_MODES: WidgetContactFormModeEnum[] = ['by_messages', 'by_events'];
export const CONTACT_FORM_FIELD_TYPES: ContactFormFieldType[] = [
  'text',
  'email',
  'phone',
  'foreign_phone',
  'number',
  'select',
];
export const CONTACT_FORM_CHOICE_FIELD_TYPES: ContactFormFieldType[] = ['select'];
export const CONTACT_FORM_ALIAS_PATTERN = /^[a-z][a-z0-9_]*$/;
export const MAX_CONTACT_FORM_FIELDS = 20;
export const PLACEMENTS: WidgetPlacementEnum[] = ['bottom_right', 'bottom_left'];

export const METRIKA_EVENTS = [
  'WIDGET_SHOWN',
  'PREVIEW_OPEN',
  'CHAT_OPEN',
  'FIRST_MESSAGE_SENT',
  'AUTH_FORM_SHOWN',
  'AUTH_FORM_SUBMIT',
] as const;

export const PRESET_FORM_ID = 'preset-settings-form';
export const BUTTON_BORDER_RADIUS_MAX = 50;
export const WIDGET_BORDER_WIDTH_MAX = 12;
